module.exports = __webpack_public_path__ + "static/media/trinidad-y-tobago.44b6357e.png";